import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'no-ad-hoc-component',
  templateUrl: './no-ad-hoc.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule]
})
export class NoAdHocComponentComponent {
  @Output() onAction = new EventEmitter();
  adHocModal(){
    this.onAction.emit({action:"createAdHoc"});
  }

}